import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownDashed = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 7 14",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M2.78572 3.99996V2.49996L4.28572 2.49996V3.99996L2.78572 3.99996Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.78572 1.5L2.78554 0L4.28536 0L4.28554 1.5H2.78572Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M0 9.62783L0.714286 8.93016L3.50003 12.0697L6.28571 8.93016L7 9.62783L3.50003 13.465L0 9.62783Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.78572 6.49996V4.99996H4.28572V6.49996H2.78572Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.78572 8.96508V7.49996H4.28572V8.96508H2.78572Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgArrowDownDashed);
export default ForwardRef;
